<template>
  <section>
    <div class="pop-room asset-detail-pop" v-if="assetRepairDetail.status">
      <h3 class="title">资产维修明细</h3>
      <a href="javascript:;" @click="hidePop()" class="iconfont icon-close"></a>
      <div class="pop-cont" style="max-height:400px;overflow-y:auto;">

        <!-- 资产维修条目 -->
        <p style="padding: 10px 0 0;color: #d93c37;">本次维修的资产列表</p>
        <el-table class="table-change-list" :data="assetRepairDetail.data.assets" style="width: 100%">
          <el-table-column prop="number" label="资产编号" width="110px">
          </el-table-column>
          <el-table-column prop="name" label="资产名称">
          </el-table-column>
          <el-table-column prop="attribute.name" label="资产属性" width="90px">
          </el-table-column>
          <el-table-column prop="spec" label="规格型号" width="140px">
          </el-table-column>
          <el-table-column prop="price" label="购置金额" width="75px">
          </el-table-column>
          <el-table-column prop="purchaseTime" label="购置时间" width="110px">
          </el-table-column>
        </el-table>


        <p style="padding: 10px 0 10px;color: #d93c37;">维修信息</p>
        <div style="border:1px #ccc solid;overflow:hidden;padding-bottom:10px;">
          <el-col :span="22" class="showDataDetail">
            <ul style="padding-top:20px;">
              <li>
                <label>维修单号:</label>
                <span>{{assetRepairDetail.data.number}}</span>
              </li>
              <li>
                <label>维修状态:</label>
                <span>{{repairArr[assetRepairDetail.data.repairStatusCode]}}</span>
              </li>
              <li>
                <label>业务日期:</label>
                <span>{{assetRepairDetail.data.repairTime}}</span>
              </li>
              <li>
                <label>维修花费:</label>
                <span>{{assetRepairDetail.data.cost}}</span>
              </li>
              <li class="w3">
                <label>维修内容:</label>
                <span>{{assetRepairDetail.data.content}}</span>
              </li>
              <li>
                <label>报修人:</label>
                <span>{{assetRepairDetail.data.repairer?assetRepairDetail.data.repairer.name:''}}</span>
              </li>
              <li class="remark">
                <label>备注:</label>
                <span>{{assetRepairDetail.data.remark}}</span>
              </li>
            </ul>
          </el-col>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    // props: ["repairDetailStatus", "repairDetailData"],
    computed: {
      ...mapState({
        assetRepairDetail: state => state.asset.assetRepairDetail,
      })
    },
    data() {
      return {
        attributeArr: ['自制', '采购', '租赁', '出租', '其他'],
        repairArr: ['维修中', '已完成'],
        // dataList: []
      }
    },
    created() {},
    methods: {
      // 隐藏表单
      hidePop() {
        this.$store.commit('set_assetRepairDetail', {
          status: false,
          data: {}
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/assetRepairDetail.vue